import axios from '@api'

export default {
    getCompanyListById(companyId) {
        return axios.get(`api/management/company/` + companyId);
      }, 
    getCompanyList(json) {
        return axios.post(`api/management/company/list`, JSON.stringify(json));
      },
    getddlCompanyList() {
        return axios.get(`api/management/company/dropdown`);
      },
      deleteMasterCompany(jsonCompany) {
        return axios.put('api/management/company/delete', jsonCompany)
      },
      saveMasterCompany(jsonCompany) {
        return axios.post(`api/management/company/save/`, jsonCompany);
      },
}